import { render, staticRenderFns } from "./stockAdjustmentDetails.vue?vue&type=template&id=e56d04ac&"
import script from "./stockAdjustmentDetails.vue?vue&type=script&lang=js&"
export * from "./stockAdjustmentDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports